// src/App.js

import React from "react";
import "./App.css";
import Header from "./components/Header";
import About from "./components/About";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Experience from "./components/Experience";
import Contact from "./components/Contact";

function App() {
    return (
        <div className="App">
            <Header />
            <main>
                <About />
                <Skills />
                <Experience />
                <Projects />
                <Contact />
            </main>
        </div>
    );
}

export default App;
